import React, {Component} from 'react'
import {Link, withRouter} from 'react-router-dom'
import {Menu, Icon} from 'antd'
import {connect} from 'react-redux'

import logo from '../../assets/images/logo.png'
import './index.less'
import {setHeadTitle} from '../../redux/actions'

const SubMenu = Menu.SubMenu;

/*
左侧导航的组件
 */
class LeftNav extends Component {

  /*
  判断当前登陆用户对item是否有权限
   */
  hasAuth = (item) => {
    const {url, isPublic} = item

    const menus = this.props.user.role.menus
    const username = this.props.user.username
    /*
    1. 如果当前用户是admin
    2. 如果当前item是公开的
    3. 当前用户有此item的权限: url有没有menus中
     */
    if(username==='admin' || isPublic || menus.indexOf(url)!==-1) {
      return true
    } else if(item.children){ // 4. 如果当前用户有此item的某个子item的权限
      return !!item.children.find(child =>  menus.indexOf(child.url)!==-1)
    }

    return false
  }


  /*
  根据menu的数据数组生成对应的标签数组
  使用reduce() + 递归调用
  */
  getMenuNodes = (menuList) => {
    // 得到当前请求的路由路径
    const path = this.props.location.pathname
    return menuList.reduce((pre, item) => {
        // 向pre添加<Menu.Item>
        if(!item.children) {
          // 判断item是否是当前对应的item
          if (item.url===path || path.indexOf(item.url)===0) {
            // 更新redux中的headerTitle状态
            this.props.setHeadTitle(item.name)
          }

          pre.push((
            <Menu.Item key={item.url}>
              <Link to={item.url} onClick={() => this.props.setHeadTitle(item.name)}>
                <Icon type={item.icon}/>
                <span>{item.name}</span>
              </Link>
            </Menu.Item>
          ))
        } else {
          // 查找一个与当前请求路径匹配的子Item
          const cItem = item.children.find(cItem => path.indexOf(cItem.url)===0)
          // 如果存在, 说明当前item的子列表需要打开
          if (cItem) {
            this.openKey = item.url
          }


          // 向pre添加<SubMenu>
          pre.push((
            <SubMenu
              key={item.url}
              title={
                <span>
              <Icon type={item.icon}/>
              <span>{item.name}</span>
            </span>
              }
            >
              {this.getMenuNodes(item.children)}
            </SubMenu>
          ))
        }

      return pre
    }, [])
  }

  /*
  在第一次render()之前执行一次
  为第一个render()准备数据(必须同步的)
   */
  componentWillMount () {
    let menuLists = this.props.user.role.menus;
    this.menuNodes = this.getMenuNodes(menuLists)
  }

  render() {
    // debugger
    // 得到当前请求的路由路径
    let path = this.props.location.pathname
    console.log('render()', path)
    if(path.indexOf('/product')===0) { // 当前请求的是商品或其子路由界面
      path = '/product'
    }

    // 得到需要打开菜单项的key
    const openKey = this.openKey

    return (
      <div className="left-nav">
        <Link to='/' className="left-nav-header">
          <img src={logo} alt="logo"/>
          <h1>Zk后台</h1>
        </Link>

        <Menu
          mode="inline"
          theme="dark"
          selectedKeys={[path]}
          defaultOpenKeys={[openKey]}
        >

          {
            this.menuNodes
          }

        </Menu>
      </div>
    )
  }
}

/*
withRouter高阶组件:
包装非路由组件, 返回一个新的组件
新的组件向非路由组件传递3个属性: history/location/match
 */
export default connect(
  state => ({user: state.user}),
  {setHeadTitle}
)(withRouter(LeftNav))